import React from 'react';
import './Spinner.scss';

const Spinner = () => {
  return <span className="loader"></span>;
};

export default Spinner;
